import type { WLCustomerUserConfigAllTime } from '../../types/WLCustomerUserConfig';
import { migrateBlottersToBlotters3 } from './Blotters3Migration';
import { migrateDefaultSymbol } from './DefaultSymbolMigration';
import type { WLConfigMigration } from './types';

// All our migrations in order. They will be run from top to bottom.
const migrations: WLConfigMigration[] = [migrateDefaultSymbol, migrateBlottersToBlotters3];

export function runWLConfigMigrations(config: Partial<WLCustomerUserConfigAllTime>) {
  let current = config;
  let mergedDiff: Partial<WLCustomerUserConfigAllTime> = {};

  for (const migration of migrations) {
    const result = migration(current);
    current = result.config;
    mergedDiff = { ...mergedDiff, ...result.diff };
  }

  return { config: current, diff: mergedDiff };
}
